import Badge from '~/themes/base/components/atom/Badge'

export default {
  extends: Badge,
}
